import CONFIG from "configuration/environment"
import _ from "lodash"

const theme = CONFIG.REACT_APP_THEME_NAME

const LazyImportPlugin = {
  type: "backend",
  read(language, namespace, callback) {
    // Carbonoffset, meal, lounge associated keys are included in ancillary/translation.json.
    // Hence, Ignoring their namespaces as there is no separate translation file created for them.

    if (!_.includes(["carbonoffset", "meal", "lounge", "translation"], namespace)) {
      import(
        /* webpackChunkName: "i18n/[request]" */ `themes/${theme}/lang/${language}/${namespace}/translation.json`
      )
        .then(obj => {
          callback(null, obj)
        })
        .catch(() => {
          import(
            /* webpackChunkName: "i18n/[request]" */ `themes/${theme}/lang/en/${namespace}/translation.json`
          )
        })
    } else {
      callback()
    }
  }
}

export default LazyImportPlugin
